export function stripScripts(html: string): string {
  return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
}

export function containsJavaScript(html: string): boolean {
  if (/<script[\s>]/i.test(html)) return true;
  if (/\bon\w+\s*=/i.test(html)) return true;
  if (/javascript\s*:/i.test(html)) return true;
  return false;
}

export enum IFrameServiceType {
  GOOGLE_MAP = 'googleMap',
  YOUTUBE = 'youtube',
  INSTAGRAM = 'instagram',
}

export function validateIframeSrc(html: string, serviceType: IFrameServiceType): string | null {
  if (containsJavaScript(html)) {
    return 'JavaScriptは許可されていません。scriptタグ、イベント属性(onclick等)、javascript:は使用できません。';
  }

  // Use DOMParser for robust iframe detection
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const iframes = doc.getElementsByTagName('iframe');

  if (iframes.length === 0) {
    return 'iframeタグが見つかりません。';
  }
  if (iframes.length > 1) {
    return 'iframeタグは1つだけ入力してください。';
  }

  const srcAttr = iframes[0].getAttribute('src');
  if (!srcAttr) {
    return 'iframeタグにsrc属性が見つかりません。';
  }
  const src = srcAttr.trim();

  // Use URL parser for secure domain validation
  let url: URL;
  try {
    url = new URL(src);
  } catch {
    return 'URLが不正です。';
  }

  if (url.protocol !== 'https:') {
    return 'httpsのURLのみ許可されています。';
  }

  const hostname = url.hostname.toLowerCase();
  const { pathname } = url;

  switch (serviceType) {
    case IFrameServiceType.GOOGLE_MAP: {
      const isGoogleMapsDomain = (hostname.endsWith('google.com') && pathname.includes('/maps'))
        || hostname.startsWith('maps.google.');
      if (!isGoogleMapsDomain) {
        return 'Google MapのiFrameを入力してください。';
      }
      break;
    }
    case IFrameServiceType.YOUTUBE: {
      const isYouTubeDomain = hostname === 'youtu.be'
        || hostname === 'youtube.com'
        || hostname.endsWith('.youtube.com');
      if (!isYouTubeDomain) {
        return 'YouTubeのiFrameを入力してください。';
      }
      break;
    }
    case IFrameServiceType.INSTAGRAM: {
      const isInstagramDomain = hostname === 'instagram.com'
        || hostname.endsWith('.instagram.com');
      if (!isInstagramDomain) {
        return 'InstagramのiFrameを入力してください。';
      }
      break;
    }
    default:
      break;
  }
  return null;
}
